import { endpoint } from "../../../common/constant"
import { fetchAllPostPromisedData, fetchAllPromisedData } from "../../../common/utils/methods/commonMethods/utilityMethod"
import { successToast } from "../../../common/utils/methods/toasterFunctions/function";

export const requestSupplementaryId = async (applicationDetails) => {
  const {
    studentName,
    psid,
    applicationId,
    businessAreaDispValue: businessAreaValue,
    courseId,
    programActions: programAction,
    classes,
  } = applicationDetails || {};
  const reqBody = {
    supplementaryRequestDto: [
      {
        studentName,
        psid,
        applicationId,
        businessAreaValue,
        courseId,
        programAction,
        classes,
      },
    ],
  };
  const res = await fetchAllPostPromisedData(endpoint.studentSupplementary.requestSupplementaryId, reqBody, 'post');
  if(res?.code===200) {
    successToast(res?.message);
  }

  return res;
}


const enabledBranchesForGoogleMeet = [
  "IC006","JP001","AG034","AB443","AD074","AD157","AG032","AJ427","AK409","AM038","AM047","AM054","AM061","AM081",
  "AN062","AN319","AP652","AP669","AP691","AR027","AS677","AS678","AS679","AS680","AT311","BG442","BG446","BG447",
  "BH024","BH067","BH083","BH410","BH430","BI040","BJ042","BO063","BO127","BR041","BR671","BR672","BR673","CG192",
  "CG692","CH012","CL051","CN023","CN030","CN097","CN098","CO052","CO425","DG123","DH010","DH011","DL477","DL482",
  "DL483","DL485","DL487","DN690","DP135","DW005","DW087","FB019","GJ422","GJ458","GJ468","GJ600","GJ609","GJ623",
  "GJ648","GJ649","GJ653","GJ664","GJ682","GN009","GO066","GO421","GP073","GW076","HB065","HD411","HP491","HR026",
  "HR197","HR432","HR469","HR470","HR495","HR612","HR624","HR685","HR686","HU401","HW125","HY044","HY045","HY082",
  "HY095","HY096","ID050","ID078","JD029","JD075","JH139","JH445","JH674","JH675","JK687","JK688","JK689","JM118",
  "JP002","JP070","JP072","JR021","JR049","KA429","KA436","KA619","KA626","KA628","KA636","KA637","KA640","KA650",
  "KA654","KA667","KK108","KK109","KK110","KK111","KK166","KK194","KL043","KL046","KL048","KL089","KL460","KL615",
  "KL676","KM440","KN094","KN178","KO069","KP053","KR033","KR036","KR084","KT404","LD022","MB015","MB016","MB017",
  "MB018","MB068","MB415","MB417","MB419","MD400","MD465","MG444","MH476","MH478","MH480","MH493","MH494","MH607",
  "MH616","MH631","MH633","MH634","MH642","MH643","MH645","MH647","MH651","MH657","MH683","MP498","MP601","MP602",
  "MP613","MP618","MP639","MR031","MR180","MY402","MY454","ND008","ND086","NE431","NN035","OR473","OR474","OR475",
  "OR662","OR663","PA059","PA060","PA144","PB452","PB471","PB472","PB611","PD459","PL037","PN014","PN085","PP025",
  "PT115","PT315","RJ462","RJ466","RJ467","RJ490","RJ608","RJ610","RJ614","RJ620","RJ681","RK020","SA438","SE003",
  "SE004","SE606","SL307","SN141","SN190","SN310","SP028","SU056","SU079","SU457","TG496","TG635","TG660","TN434",
  "TN622","TN627","TN629","TN641","TN656","TN668","TR090","TR099","TR403","UJ426","UK318","UP463","UP479","UP481",
  "UP484","UP486","UP489","UP497","UP617","UP630","UP632","UP644","UP646","UP666","UT621","VD039","VD080","VJ091",
  "VL439","VN152","VN156","VZ057","VZ088","WB314","WF064","WR093","VS521","MP697","UP694","DL695","RJ696","BR698",
  "DL699","GJ700","GJ701","GJ702","HR704","JK705","JH706","MP707","MP709","MH710","MH711","MH712","MH714","RJ716",
  "TN718","TN719","TG720","UP723","UP727","UT728","AP492","BR733","JH734","UP735","GJ736","TN737","DL738","UP739",
  "OR740","JK320","WB321","WB322","TN775","MB418","JK325","CE351","CE353","CE354","CE355","CE352","CE356","CE357",
  "CE358","CE359","CE360","CE361","UP783","MH784","HO899","BR326","JH327","UP328","JH329","UP334","UP330","OR345",
  "BR331","UP364","TG338","UP365","UP336","OR381","MH371","BR346","OR347","UP339","PB369","RJ370","UP386","OD332",
  "JH348","BR376","BR366","BR367","UP382","JH384","OD340","TN350","BR368","UP337","UP394","BR335","JH349","UP343",
  "UP341","HO413","MP501","UP333","UP395","UP396","OR377","MH385","UP342","CG362","BR363","HR304","UP116","RJ301",
  "CG112","UP114","AS119","BR387","BR388","UP390","UP392","MP391","BR147","MP121","JH120","OR344","UP393","JH383",
  "UP389","BR372","UP379","OR380","DL305","UK511","DL510","MP502","UP503","UP512","NL513","UP518","AS517","CH519",
  "RJ520","KA522","MH524","RJ514","UP516","RJ520","KA522","MH524","RJ514","UP516","NL513","MP515","MP525","MP526",
  "UP527","MH528","KA529","RJ530","HP533","HP534","HR535","RJ536","HP537","MP539","MP540","RJ541","MH543","GJ544",
  "UP545","MH547","UP546","MH548","AP551","HR552","DL786","CT554","JK785","TG549","KA556","TG550","TG553","MH555",
  "UP560","UP561","UP558","RA559","UP531","RJ532","AP551","MH542","KA557","HR562","KA563","CT564","CT565","BR566",
  "KA567","BR566","CT564","CT565","AS568","MP569","RJ570","PB571","BR572","KA573","HR574","MH575","MH582","DL583",
  "KA584","ST214","MH787","WB576","WB577","WB578","WB579","WB580","UP789","TN790","BU100","TS791","TS792","TS793",
  "TS794","TS795","GT845","UT581","TS976"
];



export  const isBuIntoConfig = (studentDetails)=>{
  if(studentDetails?.businessAreaDispValue && enabledBranchesForGoogleMeet.includes(studentDetails?.businessAreaDispValue)){
    return false;
  }
  return true;
}

export const initiateCompletionRefund = async (applicationId,psid) => {
  return fetchAllPromisedData(`${endpoint?.refund.initiateCompletionRefund}?psid=${psid}&applicationId=${applicationId}`, true)
}